export default {"src":"/_next/static/media/microsoft.9e8fe786.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};